import { SecondaryButton, IconPrint, TableHeaderButtons } from 'cdk-radial';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { ExportOrArchiveDialog } from 'components';
import { getPaymentDateByPrintChecks } from 'components/PaymentDatePicker/slice';
import { usePrintSummarySheet } from 'hooks';
import { PrintOptionsContent } from 'pages/AuthorizePaymentPage/PrintOptionsContent';
import { useAppSelector } from 'store/hooks';
import { formatLocaleDate } from 'utils/dateUtils';
import { labels } from '../dialogs/PrintChecksDialog/messages';
import { pageHeader, labels as printLabels } from './messages';
import { getSelectedVendors } from './slice';
import { StyledTableHeaderCustomContent, StyledTableTitle } from './styled';
import { ReviewChecksCustomTableHeaderType } from './types';
import { useReviewChecksTableColDefs } from './useReviewChecksTableColDefs';
import { getReviewChecksTotal } from './utils';

export const ReviewChecksCustomTableHeader = ({
  cashCompany,
  cashAccount,
  cashDisbursementsJournal,
  postingDescription,
  gridRef
}: ReviewChecksCustomTableHeaderType): React.JSX.Element => {
  const selectedVendors = useAppSelector(getSelectedVendors);
  const intl = useIntl();
  const columnDefs = useReviewChecksTableColDefs();
  const reviewChecksTotal = getReviewChecksTotal(selectedVendors);
  const paymentDate = useAppSelector(getPaymentDateByPrintChecks);
  const [downloadClicked, setDownloadClicked] = useState<boolean>(false);
  const { printSummarySheetTitle, printSummarySheetLabel } = labels;
  const { openPrintSummarySheet } = usePrintSummarySheet({
    intl,
    printSummarySheetTitle,
    columnDefs,
    selectedVendors
  });
  const handlePrintSummarySheet = () => {
    openPrintSummarySheet();
  };

  const onDownloadClick = () => setDownloadClicked(true);

  const onDownloadClose = () => setDownloadClicked(false);

  return (
    <>
      <StyledTableHeaderCustomContent
        id="composed-table"
        customHeaderContent={
          <>
            <StyledTableTitle>{` ${intl.formatMessage(
              printLabels.printChecksTable
            )} (${selectedVendors.length})`}</StyledTableTitle>
            <>
              {downloadClicked && (
                <ExportOrArchiveDialog
                  isOpen={downloadClicked}
                  onClose={onDownloadClose}
                  gridRef={gridRef}
                  columnDefs={columnDefs}
                  tableHeaderFilters={{
                    tableTitle: `${intl.formatMessage(
                      pageHeader.reviewChecks
                    )} ${Number(reviewChecksTotal)}`,
                    total: Number(reviewChecksTotal),
                    cashCompany,
                    cashAccount,
                    cashDisbursementsJournal,
                    postingDescription,
                    paymentDate: formatLocaleDate(paymentDate, 'en')
                  }}
                />
              )}
              <TableHeaderButtons
                id="tableSimple"
                onDownloadClick={onDownloadClick}
                isSearchable={false}
                isPrintable={false}
              />
              <SecondaryButton
                dataTestId="secondary-button"
                iconColor="primary"
                iconSize={24}
                onClick={handlePrintSummarySheet}
                icon={<IconPrint />}
                text={intl.formatMessage(printSummarySheetLabel)}
              />
            </>
          </>
        }
      />
      <PrintOptionsContent />
    </>
  );
};
